webpackJsonp([152176518627018],{

/***/ 415:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(43);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(415);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogIndex = function BlogIndex(_ref) {
	  var data = _ref.data;
	  var posts = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'content' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Blog / Shi Shu' }),
	    _react2.default.createElement(
	      'div',
	      { id: 'blog', className: 'fade' },
	      posts.filter(function (post) {
	        return post.node.frontmatter.title.length > 0;
	      }).map(function (_ref2, index) {
	        var post = _ref2.node;
	        var fields = post.fields,
	            frontmatter = post.frontmatter;
	
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'blog-post', key: post.id },
	          _react2.default.createElement(
	            'time',
	            { dateTime: frontmatter.date },
	            post.frontmatter.date
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: post.fields.slug },
	              post.frontmatter.title
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            post.frontmatter.description
	          )
	        );
	      })
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = BlogIndex;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-index-js-1ae807b0c24bcc1b83ce.js